import React, { Component } from 'react';
import './Publications.css';

class Publications extends Component {
  render() {
    return (
      <div id="publications" className="row home-block">
        <div>
          <h2 className="title">Papers</h2>




          {/* Preprint */}
          <div>
            <div className="type-publication">Preprint</div>
            <ul>
              <li>
                <a href="https://arxiv.org/pdf/2510.16462">
                  Buzz, Choose, Forget: A Meta-Bandit Framework for Bee-Like Decision Making - E Claeys, E Kerjean, JM Loubes - 2025 {' '}
                </a>
              </li>
              <li>
                <a href="https://arxiv.org/pdf/2507.20708">
                  Exposing the illusion of fairness: Auditing vulnerabilities to distributional manipulation attacks - V Lafargue, AL Monteiro, E Claeys, L Risser, JM Loubes - 2025{' '}
                </a>
              </li>
            </ul>
          </div>




          {/* International conferences */}
          <div>
            <div className="type-publication">International conference</div>
            <ul>
               <li>
                <a href="https://arxiv.org/pdf/2507.00090">
                  Generating Heterogeneous Multi-dimensional Data: A Comparative Study -M Corbeau, E Claeys, M Serrurier, P Zaraté -{' '}
                  <em>
                     IEEE International Conference on Systems, Man, and Cybernetics (SMC) 
                  </em>
                  , 2025 Vienna 
                </a>
              </li>

               <li>
                <a href="https://link.springer.com/chapter/10.1007/978-3-032-06129-4_18">
                  Fairness is in the details: Face Dataset Auditing {' '}
                  <em>
                    Joint European Conference on Machine Learning and Knowledge Discovery in Databases (ECML PKDD)
                  </em>
                  , 2025 Porto 
                </a>
              </li>

                             <li>
                <a href="https://link.springer.com/chapter/10.1007/978-3-031-70378-2_22">
                  Time Series Clustering for Enhanced Dynamic Allocation in A/B Testing {' '}
                  <em>
                    Joint European Conference on Machine Learning and Knowledge Discovery in Databases (ECML PKDD)
                  </em>
                  , 2024 Vilinus 
                </a>
              </li>

               <li>
                <a href="https://ieeexplore.ieee.org/document/9413526/">
                  Online hyper-parameter tuning for the contextual bandits - Djallel Bouneffouf, Emmanuelle Claeys{' '}
                  <em>
                    ICASSP 2021 IEEE International Conference on Acoustics, Speech and Signal Processing 
                  </em>
                  , Toronto, Canada
                </a>
              </li>


              <li>
                <a href="https://hal.archives-ouvertes.fr/hal-02572428/">
                  Learning Exploration for Contextual Bandit - D. Bouneffouf, E. Claeys -{' '}
                  <em>
                    Automation in Machine Learning (in conjunction with the KDD 2019
                    Conference)
                  </em>
                  , Anchorage, AK, United States, August 2019.
                </a>
              </li>
              <li>
                <a href="https://hal.archives-ouvertes.fr/hal-02572444/document">
                  Regression Tree for Bandits Models in A/B Testing - E. Claeys, P.
                  Gançarski, M. Maumy-Bertrand -{' '}
                  <em>
                    International Symposium on Intelligent Data Analysis (IDA), London,
                    United Kingdom, pages 52–62, October 2017
                  </em>{' '}
                  <b>Extended book chapter</b>
                </a>
              </li>
            </ul>
          </div>

          {/* Journal */}
          <div>
            <div className="type-publication">Journal</div>
            <ul>
              <li>
                <a href="https://ieeexplore.ieee.org/abstract/document/9422268">
                  Dynamic allocation optimization in A/B tests using classification-based
                  preprocessing - E. Claeys, P. Gançarski, M. Maumy-Bertrand, H. Wassner -{' '}
                  <em>
                    IEEE Transactions on Knowledge and Data Engineering (TKDE), 03 May 2021
                  </em>
                </a>
              </li>
              
            </ul>
          </div>

          {/* National conferences */}
          <div>
            <div className="type-publication">National Paper</div>
            <ul>

              <li>
                <a href="https://jds2024.sciencesconf.org/529584/document">
                  Analyse d'une compétition mondiale de football féminin par Process Mining - L Lacroix, J Treilhou, E Claeys, S Dejean, {' '}
                  <em>55èmes Journées de Statistique de la SFdS (2024)</em>
                </a>{' '}
              </li>



              <li>
                <a href="https://hal.archives-ouvertes.fr/hal-02572655">
                  Intégration des séries temporelles dans les A/B-Tests - E. Claeys,
                  P. Gançarski, M. Maumy-Bertrand,{' '}
                  <em>E.G.C., Brussels, January 2020</em>, vol. RNTI-E-36, pp. 121–132{' '}
                  <b>Avec Acte</b>
                </a>{' '}
                <b>
                  - Article nominé au prix de meilleur papier "Académique" et au prix de
                  meilleur papier "Applicatif"
                </b>
              </li>

              <li>
                <a href="https://hal.archives-ouvertes.fr/hal-02572670">
                  Gestion des logs dans les problèmes de bandits contextuels - E. Claeys,
                  P. Gançarski, M. Maumy-Bertrand,{' '}
                  <em>
                    Journées d&apos;Étude en Statistique, Nancy, France – June 2019
                  </em>
                </a>
              </li>

              <li>
                <a href="https://hal.archives-ouvertes.fr/hal-02572688">
                  Système de recommandation : algorithmes et application à la plateforme
                  KeeSeeK - E. Claeys, M. Maumy-Bertrand, F. Bertrand, T. Nengsih, A.
                  Delyon, A. Vidal –{' '}
                  <em>
                    Journées d&apos;Étude en Statistique, Nancy, France – June 2019
                  </em>
                </a>
              </li>
              <li>
                <a href="https://hal.science/hal-02572764/document">
                 Causalité et apprentissage automatique, E Claeys, M Maumy-Bertrand, L Bottou {' '}
                  <em>Journées d'Étude en Statistique 2018</em>
                </a>{' '}
              </li>
              <li>
                <a href="https://hal.archives-ouvertes.fr/hal-02572695/document">
                  Approche contextuelle par régression pour les tests A/B - E. Claeys,
                  P. Gançarski, M. Maumy-Bertrand –{' '}
                  <em>EGC, Paris, January 2018</em>, vol. RNTI-E-34, pages 269–274.{' '}
                  <b>Avec Acte</b>
                </a>
              </li>

              <li>
                <a href="https://hal.archives-ouvertes.fr/hal-02572736/">
                  Conception d’un modèle généraliste pour l’évaluation d’un test A/B -
                  E. Claeys, P. Gançarski, M. Maumy-Bertrand –{' '}
                  <em>EGC, Grenoble, 2017</em>, vol. RNTI-E-33, pages 423–424.{' '}
                  <b>Avec Acte</b>
                </a>
              </li>

              <li>
                <a href="https://arxiv.org/pdf/2005.02209.pdf">
                  Approche paramétrique de bandits pour le test A/B - E. Claeys,
                  P. Gançarski, M. Maumy-Bertrand –{' '}
                  <em>
                    Conférence Nationale sur les Applications pratiques de l&apos;Intelligence
                    Artificielle (APIA), Caen, France, January 2017
                  </em>, pages 19–25. <b>Avec Acte</b>
                </a>
              </li>
            </ul>
          </div>

          {/* Book */}
          <div>
            <div className="type-publication">Book</div>
            <ul>
              <li>
                Modélisation statistique par la pratique avec R – F. Bertrand,
                M. Maumy-Bertrand, E. Claeys –{' '}
                <em>Sciences Sup, Dunod (Eds), 2019.</em>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Publications;



// WEBPACK FOOTER //
// ./src/Components/Publications/Publications.js